export default __webpack_public_path__ + "static/media/portfolio1.327c62cb.png";